<div class="flex justify-between items-center">
  <h2 class="flex items-center">
    <mat-icon class="mr-4" svgIcon="icon_drag_16" />
    Generate Data
  </h2>

  <div class="flex gap-8 items-end">
    <button
      (click)="fillTable()"
      [disabled]="fillTableDisabled()"
      blazeButton="primary"
      class="uppercase"
      data-cy="BlazeTable:GenerateData:Fill"
    >
      Fill Table
      @if (requestInProgress()) {
        <blaze-element-loading-indicator [isVisible]="requestInProgress()" />
      }
    </button>
    <button blazeIconButton="secondary" blazeIconButtonSize="lg" (click)="closePanel.emit(true)"
      ><mat-icon svgIcon="icon_close_16"
    /></button>
  </div>
</div>

<div class="flex justify-center gap-48 text-primary-darker mt-24 max-h-[650px]">
  @let linkedDatasets = availableLinkedDatasets();
  @let containsLinkedTables = !!linkedDatasets.length;

  <div class="flex flex-col" [class.flex-2]="containsLinkedTables">
    <div class="flex justify-between items-center mb-24">
      <p class="text-13 font-medium">Number of rows</p>
      <input
        (ngModelChange)="numberOfRows.set($event)"
        [ngModel]="numberOfRows()"
        class="field-specific-input"
        data-cy="BlazeTable:GenerateData:Rows"
        min="1"
        type="number"
      />
    </div>
    <p class="text-14 font-medium mb-4">General Description of Your Data</p>
    <p class="text-13 mb-24">
      We’ll create sample rows for the selected tables using your column definitions.
    </p>

    <textarea
      [(ngModel)]="generalDescription"
      class="general-description-input"
      data-cy="BlazeTable:GenerateData:Desc"
      placeholder="Generate rows of sample data for an inventory management system. Stock quantity should range from 10 to 500 units, and restock dates should fall within the last 6 months."
    ></textarea>
  </div>

  <blaze-scroller [class.flex-3]="containsLinkedTables">
    <div class="flex flex-col pr-8">
      <p class="text-14 font-medium mb-4">Field Specifics</p>
      <p class="text-13 mb-24">
        Optionally, customize each column by defining specific details like ranges or formats.
      </p>
      <div class="flex gap-8 items-start">
        @if (containsLinkedTables) {
          <div class="flex flex-col gap-8 w-[160px]">
            @let selectedDataset = selectedDatasetId();

            <div>
              @let isSelectedMainDataset = selectedDataset === datasetId();
              <button
                (click)="selectedDatasetId.set(datasetId())"
                [class.selected]="isSelectedMainDataset"
                class="dataset-button"
              >
                <span class="truncate">
                  {{ datasetName() }}
                </span>
                @if (isSelectedMainDataset) {
                  <mat-icon svgIcon="icon_arrow_right_24" />
                }
              </button>
            </div>
            <p class="mt-16 font-medium text-primary-darker">Linked Tables Fields</p>
            @for (dataset of linkedDatasets; track dataset.datasetId) {
              @let isSelected = selectedDataset === dataset.datasetId;
              <div class="flex flex-col">
                <button
                  (click)="selectedDatasetId.set(dataset.datasetId)"
                  [class.selected]="isSelected"
                  class="dataset-button"
                >
                  <div class="flex items-center gap-12 truncate">
                    <blaze-checkbox [formControl]="enabledDatasets.controls[dataset.datasetId]" />
                    <span class="truncate">{{ dataset.datasetName }}</span>
                  </div>
                  @if (isSelected) {
                    <mat-icon svgIcon="icon_arrow_right_24" />
                  }
                </button>
              </div>
            }
          </div>
        }
        @let formGroup = selectedFormGroup();

        <div class="flex flex-col gap-12 p-16 bg-base-white" [formGroup]="formGroup">
          @for (col of selectedColumnsInformation(); track col.columnName + col.format) {
            @if (formGroup.controls[col.columnName]) {
              <div class="flex gap-8 justify-between">
                <div class="flex flex-col justify-center min-w-[160px]">
                  <p class="text-13 font-medium">{{ col.columnName }}</p>
                  <p class="text-11">{{ col.format }}</p>
                </div>
                <input
                  [formControlName]="col.columnName"
                  [readonly]="!enabledDatasets.controls[col.datasetId].value"
                  class="field-specific-input"
                  type="text"
                />
              </div>
            }
          }
        </div>
      </div>
    </div>
  </blaze-scroller>
</div>
